import { CheckCircle2, FileText, History, Shuffle, type LucideIcon } from 'lucide-react';
import { formatarDataHora, type EventoHistoricoDto } from '@nexital/shared';
import { Avatar } from '../design-system/Avatar';
import { useLicitacao } from './contexto';
import { Modulo } from './Modulo';

/** Lista vazia fixa: o seletor do store não pode devolver uma lista nova a cada leitura (laço infinito no React). */
const NENHUM: never[] = [];

const ICONE: Record<EventoHistoricoDto['tipo'], LucideIcon> = { estado: Shuffle, documento: FileText, atividade: CheckCircle2 };
const ROTULO: Record<EventoHistoricoDto['tipo'], string> = { estado: 'Etapa', documento: 'Documento', atividade: 'Atividade' };

/**
 * "Histórico de eventos" (RQ-LIC-004) em linha do tempo: do mais recente ao mais antigo, cada evento com a data e a
 * hora, o tipo, quem fez e o que aconteceu. Separado do Cronograma (prazos futuros).
 */
export function ModuloHistorico() {
  const historico = useLicitacao((s) => s.dados?.historico ?? NENHUM);
  return (
    <Modulo titulo="Histórico de eventos" Icone={History} cor="ciano" extra={<span className="pilula pilula--informacao">{historico.length}</span>}>
      {historico.length ? (
        <ol className="linha-do-tempo">
          {historico.map((e, i) => {
            const Icone = ICONE[e.tipo];
            return (
              <li key={`${e.ocorridoEm}-${i}`} className={`linha-do-tempo__evento evento--${e.tipo}`}>
                <span className="evento__icone" aria-hidden>
                  <Icone size={14} />
                </span>
                <div className="linha-do-tempo__dados">
                  <span className="linha-do-tempo__quando">
                    <time dateTime={e.ocorridoEm}>{formatarDataHora(e.ocorridoEm)}</time> · {ROTULO[e.tipo]}
                  </span>
                  <span className="linha-do-tempo__descricao">{e.descricao}</span>
                  {e.usuario && (
                    <span className="linha-do-tempo__quem">
                      <Avatar nome={e.usuario.nome} chave={e.usuario.uuid} tamanho={18} /> {e.usuario.nome}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      ) : (
        <p className="modulo__vazio">Nada aconteceu ainda nesta licitação.</p>
      )}
    </Modulo>
  );
}
